import { Navigate, Route, Routes } from 'react-router-dom';

import { LoginPage } from './auth/LoginPage';
import { RequireAdmin } from './auth/RequireAdmin';
import { AuditLogsPage } from './features/audit/AuditLogsPage';
import { CaseDetailPage } from './features/browse/CaseDetailPage';
import { FeatureFlagsPage } from './features/flags/FeatureFlagsPage';
import { AssignmentQueuePage } from './features/browse/AssignmentQueuePage';
import { CasesPage } from './features/browse/CasesPage';
import { MonitoringSettingsPage } from './features/browse/MonitoringSettingsPage';
import { PoisPage } from './features/browse/PoisPage';
import { ReportsPage } from './features/browse/ReportsPage';
import { SubjectsPage } from './features/browse/SubjectsPage';
import { UploadCasesPage } from './features/browse/UploadCasesPage';
import { VisitsPage } from './features/browse/VisitsPage';
import { VisitDetailPage } from './features/browse/VisitDetailPage';
import { QaQueuePage } from './features/browse/QaQueuePage';
import { MonitoringPage } from './features/browse/MonitoringPage';
import { MonitoringLinksPage } from './features/browse/MonitoringLinksPage';
import { DashboardPage } from './features/browse/DashboardPage';
import { DuplicateReviewPage } from './features/duplicate-review/DuplicateReviewPage';
import { AgentDashboardPage } from './features/reporting/AgentDashboardPage';
import { ReportPage } from './features/reporting/ReportPage';
import { OrganizationMembersPage } from './features/organization-members/OrganizationMembersPage';
import { OrganizationsPage } from './features/organizations/OrganizationsPage';
import { OrgRolesPage } from './features/org-roles/OrgRolesPage';
import { RolesPage } from './features/roles/RolesPage';
import { UserRolesPage } from './features/user-roles/UserRolesPage';
import { UsersPage } from './features/users/UsersPage';
import { AdminLayout } from './layouts/AdminLayout';

export function AppRoutes() {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<RequireAdmin />}>
                <Route element={<AdminLayout />}>
                    <Route index element={<Navigate to="/users" replace />} />
                    <Route path="users" element={<UsersPage />} />
                    <Route path="organizations" element={<OrganizationsPage />} />
                    <Route path="organization-members" element={<OrganizationMembersPage />} />
                    <Route path="roles" element={<RolesPage />} />
                    <Route path="org-roles" element={<OrgRolesPage />} />
                    <Route path="user-roles" element={<UserRolesPage />} />
                    <Route path="audit-logs" element={<AuditLogsPage />} />
                    <Route path="feature-flags" element={<FeatureFlagsPage />} />
                    <Route path="dashboard" element={<DashboardPage />} />
                    <Route path="cases" element={<CasesPage />} />
                    {/* Reached from the Cases page action, deliberately absent from the sidebar. */}
                    <Route path="cases/upload" element={<UploadCasesPage />} />
                    <Route path="assignment-queue" element={<AssignmentQueuePage />} />
                    <Route path="cases/monitoring-settings" element={<MonitoringSettingsPage />} />
                    <Route path="cases/:caseId" element={<CaseDetailPage />} />
                    <Route path="visits" element={<VisitsPage />} />
                    <Route path="visits/:visitId" element={<VisitDetailPage />} />
                    <Route path="qa" element={<QaQueuePage />} />
                    <Route path="monitoring" element={<MonitoringPage />} />
                    <Route path="monitoring-links" element={<MonitoringLinksPage />} />
                    <Route path="reports" element={<ReportsPage />} />
                    <Route path="subjects" element={<SubjectsPage />} />
                    <Route path="pois" element={<PoisPage />} />
                    <Route path="duplicate-review" element={<DuplicateReviewPage />} />
                    <Route path="report" element={<ReportPage />} />
                    <Route path="agent-dashboard" element={<AgentDashboardPage />} />
                </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}
